<template>
  <div class="search-filter van-clearfix">
    <div class="search-filter-inner">
      <van-icon class="matched-keyword-trigger" name="apps-o" @click="showPopup = true"/>
    </div>
    <date-selector ref="refDateSelector"/>
    <van-popup
      class="filter-popup"
      v-model="showPopup"
      position="right"
      closeable
      :close-icon="null"
      get-container="#app"
      :style="{ 'padding-top': statusBarHeight + 'px','padding-bottom': iosBottomHeight + 'px', height: `calc(100% - ${statusBarHeight}px - ${iosBottomHeight}px)`, width: '80%' }">
      <div class="filter-popup-content">
        <scroller class="scroller" snapping>
          <van-collapse v-model="activeNames">
            <van-collapse-item name="keyword_parse">
              <strong slot="title">关键词解析结果</strong>
              <template v-for="(item, index) in keywordList">
                <van-cell
                  :key="'keyword' + index"
                  v-if="!item.implicit || !ignoreImplicit"
                  :value="item['kindDesc']">
                  <van-tag slot="title" color="#5b86e5" size="large">{{ item['matchedValue'] || item['keywordInput'] }}</van-tag>
                </van-cell>
              </template>
            </van-collapse-item>
            <van-collapse-item name="datetime">
              <strong slot="title">时间范围</strong>
              <van-radio-group v-model="datetimeReplaced" direction="horizontal">
                <van-cell
                  v-if="datetimeMatched"
                  clickable
                  @click="datetimeReplaced = datetimeMatched">
                  <van-radio :name="datetimeMatched">{{ datetimeMatched }}</van-radio>
                </van-cell>
                <van-cell
                  v-for="dtOption in datetimeOptions"
                  :key="dtOption['key']"
                  is-link
                  arrow-direction="down">
                  <div>
                    <van-popover
                      ref="dtOptionSelector"
                      style="display: block;text-align: right"
                      v-model="dtOption.showSelector"
                      trigger="click"
                      :actions="dtOption.options"
                      @select="datetimeReplaced = dtOption.selected = $event.text"
                      @open="dtOptionOpen"
                      @close="dtOptionClose"
                    >
                      <template #reference>
                        <div>
                          <van-radio slot="icon" :name="dtOption['selected']" style="pointer-events: none">{{ dtOption['selected'] }}</van-radio>
                        </div>
                      </template>
                    </van-popover>
                  </div>
                </van-cell>
              </van-radio-group>
            </van-collapse-item>
            <van-collapse-item
              v-for="filter in filters"
              :key="filter.key"
              :name="filter.key">
              <strong slot="title">{{ filter.label }}</strong>
              <van-checkbox-group v-model="filter['value']" direction="horizontal">
                <van-cell
                  v-for="item in filter['options']"
                  :key="item"
                  clickable>
                  <van-checkbox :name="item" shape="square">{{ item }}</van-checkbox>
                </van-cell>
              </van-checkbox-group>
            </van-collapse-item>
          </van-collapse>
        </scroller>
      </div>
      <div class="filter-popup-footer van-hairline--top">
        <van-button type="default" size="small" @click="showPopup = false" style="margin-right: 2em">关闭</van-button>
        <van-button type="primary" size="small" @click="onSubmit">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import DateSelector from './DateSelector'
import ReportChartData from '@/utils/reportData'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'KeywordFilterIcon',
  components: {
    DateSelector
  },
  props: {
    keyword: {
      type: String,
      default: ''
    },
    dataRegionId: {
      type: String,
      default: ''
    },
    keywordSearchHistoryId: {
      type: String,
      default: ''
    },
    keywordMatched: {
      type: Object,
      default() {
        return {
          keywordList: []
        }
      }
    },
    reportData: {
      type: Object,
      default() {
        return {
          suggest: {
            dimensions: [],
            metrics: []
          }
        }
      }
    },
    ignoreImplicit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeNames: ['keyword_parse', 'datetime'],
      showPopup: false,
      dataLoading: false,
      filtersCollapsed: true,
      reportChartData: {},
      datetimeCollapsed: true,
      datetimeMatched: '',
      datetimeReplaced: '',
      /**
       * {
       *  key: 'dimensions',
       *  label: '关联指标',
       *  collapsed: true,
       *  options: [],
       *  value: []
       * }
       */
      filters: [],
      datetimeOptions: [{
        key: 'dt_years',
        selected: '去年',
        showSelector: false,
        options: ['今年', '去年', '前年', '近2年', '近3年', '近5年', '近10年'].map(item => { return { text: item } })
      }, {
        key: 'dt_months',
        selected: '本月',
        showSelector: false,
        options: ['本月', '上个月', '上上个月', '近2个月', '近3个月', '近5个月', '近10个月'].map(item => { return { text: item } })
      }],
      searchHistory: []
    }
  },
  computed: {
    ...mapState({
      statusBarHeight: state => state.global.statusBarHeight,
      iosBottomHeight: state => state.global.iosBottomHeight
    }),
    keywordList() {
      const { keywordList } = this.keywordMatched
      return keywordList || []
    }
  },
  methods: {
    onKeywordValueChange(data) { // 没执行？
      this.keywordList[data.index].matchedValue = data.value
      let _keyword = ''
      this.keywordList.forEach(item => {
        _keyword += item.matchedValue
      })
      this.$emit('speechKeywordSearch', _keyword)
    },
    getDimensionValues(filter) {
      const _conditionFields = this.reportData['suggest']['currentConditionFields']
      const _column = _conditionFields.find(field => field['aliasName'] === filter['key'])
      if (_column) {
        this.$api.dataset.getFieldValues(_column['id']).then(res => {
          res['data'].forEach(item => {
            if (item && item[filter['key']]) {
              filter['options'].push(item[filter['key']])
            }
          })
        })
      }
    },
    onSubmit() {
      const _keywords = []
      if (this.datetimeReplaced) _keywords.push(this.datetimeReplaced)
      this.filters.forEach(filter => {
        _keywords.push(...filter['value'])
      })
      this.$emit('submit', _keywords.join(' '))
      this.$store.dispatch('speech/setInputKeyword', _keywords.join(' '))
      this.showPopup = false
    },
    onDatetimeChange(value) {
      this.datetimeReplaced = value
      this.onSubmit()
    },
    parseReportData() {
      // console.log('parseReportData')
      // search history
      this.searchHistory.push({
        keyword: this.keyword,
        keywordMatched: _.cloneDeep(this.keywordMatched)
      })
      this.filters.splice(0)
      this.reportChartData = new ReportChartData(this.reportData)
      this.keywordMatched['keywordList'].forEach(keyword => {
        if (keyword['used']) {
          // 获取时间值
          if (keyword['keywordCategory'] === 'DATETIME') {
            this.datetimeMatched = keyword['matchedValue']
            this.datetimeReplaced = keyword['matchedValue']
          }

          if (keyword['keywordCategory'] === 'DIMENSION_VALUE') {
            const _existFilter = this.filters.find(filter => filter['key'] === keyword['relationKeyword'])
            if (_existFilter) {
              _existFilter['value'].push(keyword['matchedValue'])
            } else {
              const _filter = {
                key: keyword['relationKeyword'],
                label: keyword['relationKeyword'],
                collapsed: true,
                options: [],
                value: [keyword['matchedValue']]
              }
              this.filters.push(_filter)
              this.getDimensionValues(_filter)
            }
          }
        }
      })
      const _metricsOptions = this.reportData['suggest'] ? this.reportData['suggest']['metrics'] : this.reportChartData['metrics']
      const _metrics = {
        key: 'metrics',
        label: '关联指标',
        collapsed: true,
        options: [..._metricsOptions],
        value: [...this.reportChartData['metrics']]
      }
      const _dimensionsOptions = this.reportData['suggest'] ? [...this.reportData['suggest']['dimensions']] : this.reportChartData['dimensions']
      // add 时间维度
      const _indexDatetime = _dimensionsOptions.indexOf('日期')
      if (_indexDatetime > -1) {
        _dimensionsOptions.splice(_indexDatetime, 1, ...['日期', '月份', '年月', '年份'])
      }
      const _dimensions = {
        key: 'dimensions',
        label: '关联维度',
        collapsed: true,
        options: [..._dimensionsOptions],
        value: [...this.reportChartData['dimensions']]
      }
      this.filters.push(_metrics, _dimensions)
    },
    dtOptionOpen() {
      window.history.pushState({ title: '词分时间范围选择', url: '#' }, '词分时间范围选择', '#')
      console.log('dtOptionOpen', history.state)
    },
    dtOptionClose() {
      if (history.state.title === '词分时间范围选择') {
        console.log('dtOptionClose', history.state)
        history.back()
      }
    }
  },
  watch: {
    reportData() {
      this.parseReportData()
    },
    showPopup (newVal) {
      if (newVal) {
        window.history.pushState({ title: '图表词分详情', url: '#' }, '图表词分详情', '#')
      } else if (history.state.title === '图表词分详情') {
        history.back()
      }
    }
  },
  mounted() {
    this.parseReportData()
  }
}
</script>
<style lang="less" scoped>
.filter-popup {
  .filter-popup-content {
    position: relative;
    height: calc(100% - 46px);
  }
  .filter-popup-footer {
    background: #fefefe;
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 32px;
    padding: 7px 12px;
    text-align: center;
  }
}
</style>
